import { useTranslation } from "react-i18next"
import useStore from "../../../store"
import DatePicker from "react-datepicker"
import { useState, useEffect } from "react"
import UploadUnitFile from "./UploadUnitFile"
import { HappyButton } from "../../common/Buttons"
import { Box } from '@chakra-ui/react'
import {
  AccordionItem,
  AccordionItemContent,
  AccordionItemTrigger,
  AccordionRoot,
} from "../../ui/accordion"
import { colors } from "../../../utilities/colors"

export default function MarkSoldAccordion() {
  const { t } = useTranslation()
  const markUnitSold = useStore((state) => state.markUnitSold)
  const unit = useStore((state) => state.unit)
  const createUnitFile = useStore((state) => state.createUnitFile)
  const uploadingBos = useStore((state) => state.uploadingBos)
  const bosFile = useStore((state) => state.bosFile)
  const setBosFile = useStore((state) => state.setBosFile)
  const setUploadingBos = useStore((state) => state.setUploadingBos)
  const hasBillOfSale = unit?.attributes["has-bill-of-sale"]
  const soldOn = unit?.attributes["sold-on"]
  const setShowMarkSoldForm = useStore((state) => state.setShowMarkSoldForm)
  const markingUnitSold = useStore((state) => state.markingUnitSold)
  const creatingUnitFile = useStore((state) => state.creatingUnitFile)

  const [soldOnDate, setSoldOnDate] = useState(new Date())
  const [expanded, setExpanded] = useState([])

  useEffect(() => {
    expanded.includes('mark-sold') ? setShowMarkSoldForm(true) : setShowMarkSoldForm(false)
  }, [expanded])

  const handleDateChange = (date) => {
    setSoldOnDate(date.toLocaleDateString('en-ZA'))
  }

  const handleSubmit = async () => {
    try {
      if (soldOnDate) {
        await markUnitSold(unit, soldOnDate)
      }

      if (uploadingBos) {
        const formData = new FormData()
        formData.append('unit_file[ufile]', bosFile)
        formData.append('unit_file[unit_id]', unit.id)
        formData.append('unit_file[name]', "Bill Of Sale (BOS)")
        formData.append('unit_file[description]', "Bill Of Sale")

        await createUnitFile(formData, unit.id)
      }

      setBosFile(null)
      setUploadingBos(false)
      setShowMarkSoldForm(false)
    } catch (error) {
      console.log("Error submitting form:", error)
    }
  };

  const markedSoldNoBosOrNotSold = () => {
    return (!soldOn && !hasBillOfSale) || !soldOn
  }

  return(
    <div>
      <AccordionRoot
        collapsible
        value={expanded}
        onValueChange={(e) => setExpanded(e.value)}
        borderTopColor={colors.grey700}
        borderTopWidth={1}
        borderBottomWidth={1}
        borderBottomColor={colors.grey700}
        py={2}
      >
        <AccordionItem value='mark-sold'>
          <h2>
            <AccordionItemTrigger
              pl={1}
              pr={1}
            >
              <Box as='span' flex='1' textAlign='left' data-testid='accordion-trigger'>
                {markedSoldNoBosOrNotSold() ? t('Mark Unit Sold') : t('Upload Bill of Sale')}
              </Box>
            </AccordionItemTrigger>
          </h2>
          <AccordionItemContent pb={2} pl={1}>
            {!soldOn &&
              <div className="flex items-center mb-2">
                <label className="text-sm text-grey-300 mr-2">{t("Date Sold")}</label>
                <DatePicker
                  selected={soldOnDate}
                  onChange={(date) => handleDateChange(date)}
                  className="px-4 w-32 ml-1 bg-grey-900 border-2 border-grey-700 focus:border-grey-300 focus:ring-0 rounded"
                  required
                />
              </div>
            }
            {!hasBillOfSale &&
              <div className="flex items-center mb-2">
                <label className="text-sm text-grey-300 mb-2 mr-2">{t("Bill of Sale")}</label>
                <UploadUnitFile />
              </div>
            }
            <HappyButton
              data-testid="happy-button"
              text={markedSoldNoBosOrNotSold() ? t('Mark Unit Sold') : t('Upload Bill of Sale')}
              onClick={handleSubmit}
            />
          </AccordionItemContent>
        </AccordionItem>
      </AccordionRoot>
    </div>
  )
}